export default [
  {
    path: "/bkjx",
    name: "bkjx",
    component: (resolve) => require(["@/views/PCView/bkjx/index.vue"], resolve),
  },
];
